import { render, staticRenderFns } from "./FindPwdByEmail.vue?vue&type=template&id=537b29a0"
import script from "./FindPwdByEmail.vue?vue&type=script&lang=js"
export * from "./FindPwdByEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports